import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteAtmModel = ({ atmModelId }: { atmModelId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/AtmModels/DeleteAtmModel/${atmModelId}`);
};

type QueryFnType = typeof deleteAtmModel;

type UseDeleteAtmModelOptions = {
  atmModelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteAtmModel = ({ config }: UseDeleteAtmModelOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAtmModels"]);
      addNotification(`Το Μοντέλο Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteAtmModel,
  });
};
